import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FieldWrapper } from '@scp/ui-shared/components/form-fields/FieldWrapper';
import { ClearedFieldset } from '@scp/ui-shared/theme/resets';
import { GridColumn, GridWrapper } from '@scp/ui-shared/components/grid';
import { GroupLabel, Note } from '@scp/ui-shared/components/switches/SwitchGroupBase/baseComponents';
import { ChildGroupWrapper } from '@scp/ui-shared/components/switches/SwitchGroupBaseOption/baseComponents';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { useField } from '@scp/ui-shared/components/form';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
var TEXT = {
  OPTIONAL_LABEL: '(optional)'
};
var GroupItemWrapper = styled(GridColumn)(_templateObject(), baselineToPx(2));
var LabelContentWrapper = styled.div(_templateObject2());
export var OptionTreeField = function OptionTreeField(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
      items = _ref.items,
      id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      helperText = _ref.helperText,
      labelAsNote = _ref.labelAsNote,
      dataE2eTitleLabel = _ref.dataE2eTitleLabel,
      disabled = _ref.disabled,
      isOptional = _ref.isOptional,
      onChange = _ref.onChange,
      afterLabelComponent = _ref.afterLabelComponent,
      value = _ref.value,
      maxLength = _ref.maxLength;

  var _useField = useField(name),
      _useField2 = _slicedToArray(_useField, 2),
      metaField = _useField2[1];

  var _useField3 = useField("".concat(name, ".value")),
      _useField4 = _slicedToArray(_useField3, 2),
      field = _useField4[0],
      meta = _useField4[1];

  useEffect(function () {
    onChange === null || onChange === void 0 ? void 0 : onChange(value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  var fieldWrapperError = typeof metaField.error === 'string' ? metaField.error : undefined;
  var fieldWrapperTouched = metaField.touched;
  var firstLevelValue = field.value;
  var firstLevelError = meta.error || fieldWrapperError;
  var firstLevelTouched = meta.touched || fieldWrapperTouched;
  var errorText = firstLevelTouched ? firstLevelError : undefined;

  var renderOptions = function renderOptions(items) {
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return items.map(function (_a, index) {
      var value = _a.value,
          children = _a.children,
          Component = _a.component,
          rest = __rest(_a, ["value", "children", "component"]);

      var isFirstLevelChildrenVisible = children && firstLevelValue === value;
      var showChildren = depth === 1 ? isFirstLevelChildrenVisible : false;
      return React.createElement(React.Fragment, {
        key: "".concat(id, ".").concat(index)
      }, React.createElement(GroupItemWrapper, {
        size: 12
      }, React.createElement(Component, Object.assign({
        ariaDescribedBy: ariaDescribedBy,
        parentInvalid: !!errorText,
        value: value,
        disabled: disabled,
        maxLength: maxLength
      }, rest))), showChildren && children && React.createElement(ChildGroupWrapper, null, renderOptions(children, depth + 1)));
    });
  };

  var optional = typeof label === 'string' && isOptional && " ".concat(TEXT.OPTIONAL_LABEL);
  return React.createElement(FieldWrapper, {
    id: id,
    errorText: errorText
  }, React.createElement(ClearedFieldset, null, !!label && React.createElement(LabelContentWrapper, null, React.createElement(GroupLabel, {
    as: labelAsNote ? Note : 'legend',
    "data-e2e": dataE2eTitleLabel
  }, label, optional), afterLabelComponent), helperText && React.createElement(Paragraph, {
    secondary: true
  }, helperText), React.createElement(GridWrapper, null, renderOptions(items))));
};